export default __webpack_public_path__ + "static/media/330_dummy2016-steuerberatung01-mobile-de.3b788a43.png";